<!-- =========================================================================================
    File Name: AgGridTable.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="ag-grid-demo">
        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap items-center justify-between">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-left">
                    <!-- <vs-dropdown vs-trigger-click class="cursor-pointer"> -->
                    <!--          <div class="flex items-center justify-between p-4 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ contacts.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : contacts.length }} of {{ contacts.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>-->
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <!--             <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                <span>150</span>
              </vs-dropdown-item>
          </vs-dropdown-menu>-->
                    <!-- </vs-dropdown> -->
                    <h4>Good Receive</h4>
                </div>

                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <!-- <vs-input class="mb-4 mr-4 md:mb-0" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." /> -->
                    <!-- <div class="vx-col md:w-1/2"> -->
                    <vs-button
                        @click="refreshData"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="refresh"
                        >Refresh</vs-button
                    >
                    <vs-button
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="add"
                        @click="popupNewGR = true"
                        >Add</vs-button
                    >
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        icon="remove_red_eye"
                        @click="viewData"
                        :disabled="selectedId == ''"
                        >View</vs-button
                    >
                    <!-- :to="{name:'inbound-delivery-view', params:{id:selectedId}}" -->
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        @click="removeItem"
                        icon="delete"
                        :disabled="selectedId == ''"
                        >Delete</vs-button
                    >
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        @click="filterInit"
                        icon="filter_list"
                        >Filter</vs-button
                    >
                    <!-- <vs-button class="mb-4 mr-1 md:mb-0" @click="exportExel" icon="save_alt">Export</vs-button> -->
                    <vs-button
                        class="mb-4 md:mb-0"
                        @click="
                            exportExcel({
                                endpoint:
                                    'inbound/goodreceive/report/download_report',
                                filter: filter,
                                name: 'gr_report',
                            })
                        "
                        icon="save_alt"
                        >Report</vs-button
                    >
                    <!-- </div> -->
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="contacts"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b
                    >Showing {{ dataFrom }} to {{ dataTo }} of
                    {{ dataTotal }} total entries</b
                >
            </p>
            <vs-pagination
                :total="totalPage"
                v-model="currentPage"
                :max="7"
            ></vs-pagination>
            <!--         :suppressPaginationPanel="true"
      :paginationPageSize="paginationPageSize"-->
            <!--       <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
      v-model="currentPage" />-->
            <!-- <VuePerfectScrollbar ref="agGridTablePs" class="scroll-area" :settings="psSettings" /> -->
        </vx-card>

        <!-- <vs-popup title="Create Good Receive" :active.sync="popupNewGR">
      <div class="mb-3 vx-row">
        <div class="w-full vx-col">
          <vs-input class="w-full" label="Inbound Reference" v-model="inbound_reference" />
        </div>
      </div>
      <div class="mb-3 vx-row">
        <div class="w-full vx-col">
          <label for class="vs-input--label">Client ID</label>
          <v-select :options="clientOption" v-model="client_id" :reduce="client_id => client_id.id"></v-select>
        </div>
      </div>
       <p class="mb-4 text-left"><small v-if="err != ''" class="text-danger">* {{ err }}</small></p>
       <vs-button class="mr-2" color="primary" @click="createNewGr">Submit</vs-button>
    </vs-popup> -->

        <vs-prompt
            @accept="createNewGr"
            :active.sync="popupNewGR"
            title="Create Good Receive"
        >
            <div class="con-exemple-prompt">
                <vs-input
                    placeholder="Inbound Reference *"
                    v-model="inbound_reference"
                    class="w-full mt-4 mb-2"
                />
                <vs-select
                    class="selectExample"
                    v-model="client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item
                        v-for="(item, index) in client.data"
                        :key="index"
                        :value="item.id"
                        :text="item.client_code"
                    />
                </vs-select>
                <p class="text-left">
                    <small v-if="err != ''" class="text-danger"
                        >* {{ err }}</small
                    >
                </p>
            </div>
        </vs-prompt>

        <vs-prompt @accept="fetchData" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                <vs-input
                    v-model="filter.id"
                    class="w-full mb-2"
                    label="GR ID"
                />
                <label class="vs-input--label"
                    >Reference (Multi, separated by new line)</label
                >
                <vs-textarea height="50" v-model="filter.reference_multi" />
                <label class="vs-input--label">Client</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, client)"
                >
                    <vs-select-item
                        v-for="(item, index) in client.data"
                        :key="index"
                        :value="item.id"
                        :text="item.client_code"
                    />
                </vs-select>
                <label class="vs-input--label">GR Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="5"
                        style="padding-left: 0"
                    >
                        <flat-pickr
                            class="w-full p-2 vx-col"
                            v-model="filter.gr_date_start"
                        />
                    </vs-col>
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-start"
                        vs-align="center"
                        vs-w="2"
                        >To</vs-col
                    >
                    <vs-col
                        vs-type="flex"
                        vs-justify="flex-end"
                        vs-align="center"
                        vs-w="5"
                        style="padding-right: 0"
                    >
                        <flat-pickr
                            class="w-full p-2 vx-col"
                            v-model="filter.gr_date_end"
                        />
                    </vs-col>
                </vs-row>
                <label class="vs-input--label">Supplier ID</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.supplier_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, customer)"
                >
                    <vs-select-item
                        v-for="(item, index) in customer.data"
                        :key="index"
                        :value="item.id"
                        :text="item.name"
                    />
                </vs-select>
                <label class="vs-input--label">Order Type</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.order_type_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, order_type)"
                >
                    <vs-select-item
                        v-for="(item, index) in order_type.data"
                        :key="index"
                        :value="item.id"
                        :text="item.order_type"
                    />
                </vs-select>
                <label class="vs-input--label">Warehouse ID</label>
                <vs-select
                    class="mb-2 selectExample"
                    v-model="filter.warehouse_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, warehouse)"
                >
                    <vs-select-item
                        v-for="(item, index) in warehouse.data"
                        :key="index"
                        :value="item.id"
                        :text="item.warehouses_code"
                    />
                </vs-select>
                <vs-input
                    v-model="filter.inbound_reference"
                    class="w-full mb-2"
                    label="Inbound Reference"
                />
                <label class="vs-input--label">Status</label>
                <vs-select
                    class="selectExample"
                    v-model="filter.status_id"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item
                        v-for="(item, index) in status"
                        :key="index"
                        :value="item.id"
                        :text="item.name"
                    />
                </vs-select>
                <!-- <label class="vs-input--label">Supplier</label>
              <vs-select
                  class="mb-2 selectExample"
                  v-model="filter.supplier_id"
                  width="100%"
                  autocomplete
                  @input-change="searchDropdown($event, customer)"
              >
                  <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
              </vs-select>
              <label class="vs-input--label">Req. Del. Date</label>
              <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                  <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                      <flat-pickr class="w-full p-2 vx-col" v-model="filter.req_arrival_date_start" />
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                  <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                      <flat-pickr class="w-full p-2 vx-col" v-model="filter.req_arrival_date_end" />
                  </vs-col>
              </vs-row>
              <label class="vs-input--label">Status</label>
              <vs-select
                  class="selectExample"
                  v-model="filter.status_id"
                  width="100%"
                  autocomplete
              >
                  <vs-select-item v-for="(item, index) in status" :key="index" :value="item.id" :text="item.name"/>
              </vs-select> -->
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
// import contacts from './data-inbound.json'
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { saveAs } from "file-saver";

export default {
    components: {
        AgGridVue,
        vSelect,
        flatPickr,
        // VuePerfectScrollbar
    },
    data() {
        return {
            err: "",
            isLoading: false,
            popupNewGR: false,
            inbound_reference: "",
            client_id: null,
            clientDDL: null,
            clientOption: [],
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            showFilter: false,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
            },
            columnDefs: [],
            contacts: [],
            selectedId: "",
            filter: {
                id: null,
                gr_reference: null,
                client_id: null,
                gr_date_start: null,
                gr_date_end: null,
                supplier_id: null,
                inbound_reference: null,
                order_type_id: null,
                warehouse_id: null,
                status_id: null,
                reference_multi: "",
            },
            // perfectscrollbar settings
            // psSettings: {
            //     maxScrollbarLength: 60,
            //     wheelSpeed: 1,
            //     swipeEasing: true
            // },
            client: {
                data: [],
                loading: false,
                endpoint: "master/clients",
                objectKey: "client_code",
            },
            customer: {
                data: [],
                loading: false,
                endpoint: "master/customers",
                objectKey: "name",
            },
            order_type: {
                data: [],
                loading: false,
                endpoint: "master/ordertypes",
                objectKey: "order_type",
            },
            warehouse: {
                data: [],
                loading: false,
                endpoint: "master/warehouses",
                objectKey: "warehouses_code",
            },
            status: [
                {
                    id: null,
                    name: "Any",
                },
                {
                    id: 4,
                    name: "Draft",
                },
                {
                    id: 5,
                    name: "Partially Checked",
                },
                {
                    id: 6,
                    name: "Full Checked",
                },
                {
                    id: 7,
                    name: "Already Received",
                },
                {
                    id: 8,
                    name: "Partially Put Away",
                },
                {
                    id: 9,
                    name: "Full Put Away",
                },
            ],
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            filterInitCount: 0,
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("email", null);
            } else this.gridOptions.columnApi.setColumnPinned("email", "left");
        },
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function () {
            this.fetchData();
        },
    },
    methods: {
        exportExel() {
            this.isLoading = true;
            this.$http
                .post(
                    "/inbound/goodreceive/report/download_excel",
                    this.filter,
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    var blob = new Blob([response.data], {
                        type: "application/pdf",
                    });
                    this.isLoading = false;
                    saveAs(blob, "good_receive.xlsx");
                });
        },
        createNewGr() {
            this.popupNewGR = true;
            this.err = "";
            if (this.inbound_reference == "") {
                this.err = "Inbound Reference Required";
            } else if (this.client_id == null) {
                this.err = "Client ID Required";
            } else {
                this.isLoading = true;
                let sdata = {
                    inbound_reference: this.inbound_reference,
                    client_id: this.client_id,
                };
                this.popupNewGR = false;
                this.$http
                    .post("/inbound/goodreceive/getinbound", sdata)
                    .then((resp) => {
                        this.isLoading = false;
                        this.$router.replace({
                            name: "good-receive-create",
                            params: { inbound_object: resp.data },
                        });
                    })
                    .catch((resp) => {
                        this.popupNewGR = true;
                        if (resp.response.status == 500) {
                            this.err = resp.response.data;
                        }
                        this.isLoading = false;
                    });
            }
        },
        fetchData() {
            this.isLoading = true;
            this.setFilter(this.filter);
            this.$http
                .post(
                    "inbound/goodreceive?page=" + this.currentPage,
                    this.filter
                )
                .then((resp) => {
                    this.contacts = resp.data.data;
                    this.totalPage = resp.data.last_page;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;
                    this.isLoading = false;
                })
                .catch((resp) => {
                    this.isLoading = false;
                });
        },
        refreshData() {
            this.fetchData();
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function (selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        onRemoveSelected() {
            var selectedData = this.gridApi.getSelectedRows();
            var res = this.gridApi.updateRowData({ remove: selectedData });
        },
        viewData() {
            this.$router.push({
                name: "good-receive-view",
                params: {
                    id: this.selectedId,
                },
            });
        },
        removeItem() {
            // destroy the vue listeners, etc
            // this.$destroy();
            // remove the element from the DOM
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure want to Delete this Inbound ?",
                accept: this.acceptAlert,
            });
        },
        filterInit() {
            if (this.filterInitCount < 1) {
                this.isLoading = true;
                Promise.all([
                    this.$http.post("master/customers"),
                    this.$http.post("master/ordertypes"),
                    this.$http.post("master/warehouses"),
                ])
                    .then(
                        this.$http.spread(
                            (customers, ordertypes, warehouses) => {
                                this.warehouse.data = warehouses.data.data;
                                this.customer.data = customers.data.data;
                                this.order_type.data = ordertypes.data.data;
                                this.isLoading = false;
                                this.showFilter = true;
                            }
                        )
                    )
                    .catch(() => (this.isLoading = false));
            } else {
                this.showFilter = true;
            }
        },
        acceptAlert() {
            this.isLoading = true;
            this.$http
                .delete("inbound/goodreceive/" + this.selectedId + "/destroy")
                .then((res) => {
                    this.onRemoveSelected();
                    this.$vs.notify({
                        color: "success",
                        title: "Good Receive deleted",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected Good Receive was successfully deleted",
                    });
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: "Error",
                        text: error.response.data,
                        color: "danger",
                    });
                })
                .then(() => {
                    this.fetchData();
                });
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
        // if(this.isLoading){
        //      this.$vs.loading()
        //  }
        // const el = document.querySelector('.ag-body-viewport');
        // console.log(this.$refs.agGridTablePs)
        // this.$refs.agGridTablePs.__init(el)
        // this.$refs.agGridTablePs.update()
        this.$http.post("unlock_all");

        function getClient(ax) {
            return ax.post("/master/clients");
        }

        this.$http.all([getClient(this.$http)]).then(
            this.$http.spread((clients) => {
                this.client.data = clients.data.data;
            })
        );
    },
    beforeMount() {
        const filter = this.getFilter();

        if (filter) {
            this.filter = filter;
            this.filterInitCount = 0;
        }

        if (this.isLoading) {
            this.$vs.loading();
        }
        this.fetchData();
        this.columnDefs = [
            {
                headerName: "GR ID",
                field: "id",
                width: 120,
                filter: true,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: "Client ID",
                field: "client_code",
                filter: true,
                width: 120,
            },
            {
                headerName: "Reference",
                field: "gr_reference",
                filter: true,
                width: 120,
                // pinned: 'left'
            },
            {
                headerName: "Gr Date",
                field: "gr_date",
                filter: true,
                width: 120,
            },
            {
                headerName: "Supplier Name",
                field: "supplier_name",
                filter: true,
                width: 120,
            },
            {
                headerName: "GR Status",
                field: "status_name",
                filter: true,
                width: 120,
            },
            {
                headerName: "Created Date",
                field: "created_at",
                filter: true,
                width: 120,
            },
        ];

        this.gridOptions.getRowHeight = function (params) {
            return 35;
        };
    },
};
</script>
